import React, {memo, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {useActiveItemContext} from "./useActiveItemContext";
import {useAuthorization} from "hooks";
import {INTERACTION} from "utils";

import BazaarCurrentItemInteractionToolsSkeleton from "./BazaarCurrentItemInteractionToolsSkeleton";
import BazaarCurrentItemInteractionToolsSell from "./BazaarCurrentItemInteractionToolsSell";
import BazaarCurrentItemInteractionToolsMake from "./BazaarCurrentItemInteractionToolsMake";
import BazaarCurrentItemInteractionToolsBuy from "./BazaarCurrentItemInteractionToolsBuy";
import BazaarCurrentItemDetails from "./BazaarCurrentItemDetails";

import "../style.scss"

const BazaarCurrentItemInteractionTools = ({userNftBalance}) => {
    const {isInProgress, data, chainId} = useActiveItemContext()
    const {isAuth, accessToken} = useAuthorization()
    const {t} = useTranslation()

    const {userData} = useSelector(state => state.authV2.signIn)

    const [activeTab, setActiveTab] = useState(INTERACTION.BUY)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (isInProgress) return;

        determineActiveTab();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInProgress, isAuth, chainId,userNftBalance]);


    const determineActiveTab = () => {
        if(data.lucrative_listing) {
            setActiveTab(INTERACTION.BUY);
        }

        if (!data.lucrative_listing && !userNftBalance) {
            setActiveTab(INTERACTION.MAKE_OFFER);
        }

        if(userNftBalance) {
            setActiveTab(INTERACTION.SELL);
        }

        if (!accessToken) {
            setIsLoading(false);
        }
    };

    return (
        <div className="bazaar_current-item_interaction-tools">
            <BazaarCurrentItemDetails/>
            {isLoading || isInProgress || (userNftBalance === null && !!accessToken) ? <BazaarCurrentItemInteractionToolsSkeleton/> : (
                <div className="bazaar_current-item_interaction-tools_btn-group">
                    {activeTab !== INTERACTION.MAKE_OFFER && userNftBalance > 0 &&
                        <div className="bazaar_current-item_interaction-tools_btn-group_head">
                            <div className="bazaar_current-item_interaction-tools_btn-group_head_tabs">
                                <button
                                    onClick={() => setActiveTab(INTERACTION.BUY)}
                                    {...(activeTab === INTERACTION.BUY && {className: "active"})}
                                >
                                    {t("buy")}
                                </button>
                                <button
                                    onClick={() => setActiveTab(INTERACTION.SELL)}
                                    {...(activeTab === INTERACTION.SELL && {className: "active"})}
                                >
                                    {t("sell")}
                                </button>
                            </div>
                            <span>{t("own")} {userNftBalance} {t("total")}</span>
                        </div>}
                    <div className="bazaar_current-item_interaction-tools_btn-group_tabs-content">
                        {
                            {
                                [INTERACTION.BUY]: <BazaarCurrentItemInteractionToolsBuy
                                    userUuid={userData?.id}
                                    totalOwnedNFT={userNftBalance}
                                />,
                                [INTERACTION.SELL]: <BazaarCurrentItemInteractionToolsSell
                                    totalOwnedNFT={userNftBalance}
                                />,
                                [INTERACTION.MAKE_OFFER]: <BazaarCurrentItemInteractionToolsMake/>
                            }[activeTab]
                        }
                    </div>
                </div>
            )}
        </div>
    )
}

export default memo(BazaarCurrentItemInteractionTools)
